var React = require('react');

function LineArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.2998 8H1.6123","stroke":"#141414","strokeWidth":"1.4","key":0}),React.createElement("path",{"d":"M6.47897 12.8666L1.6123 7.99997L6.47897 3.1333","stroke":"#141414","strokeWidth":"1.4","key":1})]);
}

LineArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = LineArrowLeft;

LineArrowLeft.default = LineArrowLeft;
